import React from 'react';
import { CheckIcon } from 'lucide-react';
import { included } from '../data/content';
const [main, ...tools] = included;
export function IncludedSection() {
  return <section className="w-full bg-cream-deep py-14 sm:py-16 lg:py-20" aria-labelledby="que-incluye" data-id="element-83" data-mp="3lcjegbxj6eud">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-84" data-mp="3ce7omc4hnl2z">
        <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-85" data-mp="3cer65rq887gh">
          Qué incluye
        </p>
        <h2 id="que-incluye" className="mt-3 max-w-2xl font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-86" data-mp="40s3664u7lth">
          Un ebook para entenderlo y cuatro herramientas para aplicarlo
        </h2>

        {/* Producto principal */}
        <div className="mt-8 grid grid-cols-1 gap-0 overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-card lg:grid-cols-[1fr_0.85fr]" data-id="element-87" data-mp="mxa0r46dafxn">
          <div className="p-6 sm:p-8" data-id="element-88" data-mp="ros1br4haei3">
            <span className="inline-block rounded-full bg-naranja-soft px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-naranja-dark" data-id="element-89" data-mp="rptgo7sj1n5m">
              {main.tag}
            </span>
            <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-90" data-mp="41jbc6dh6e89">
              {main.title}
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-91" data-mp="3vffami9rgqeo">
              {main.description}
            </p>
            <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-92" data-mp="e1tmllfy9bks">
              {main.bullets?.map(b => <li key={b} className="flex items-start gap-2 text-[15px] text-ink" data-id="element-93" data-mp="n0f217q4kahc">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-verde" aria-hidden="true" data-id="element-94" data-mp="my1a37qqree0" />
                  {b}
                </li>)}
            </ul>
          </div>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/ce61573f-029e-470c-8fa7-eb1fd3b6fd10.jpg" alt="El ebook y las herramientas del protocolo vistos en una tablet, un celular y una hoja de planificación" className="h-56 w-full object-cover lg:h-full" loading="lazy" data-id="element-95" data-mp="2otuvecdlk3g0" />
        </div>

        {/* Herramientas */}
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-96" data-mp="xmfa5ix0i2b9">
          {tools.map(tool => <div key={tool.title} className="flex flex-col rounded-2xl border border-ink/10 bg-white p-6 shadow-card" data-id="element-97" data-mp="11n7im9y2836h">
              <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-verde" data-id="element-98" data-mp="1bmg9uv1jj3p5">
                {tool.tag}
              </span>
              <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink" data-id="element-99" data-mp="1ggkhlgimrfra">
                {tool.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-100" data-mp="1pfo0okhsrv5s">{tool.description}</p>
            </div>)}
        </div>

      </div>
    </section>;
}